module.exports = "<svg id=\"188dfa41-f46d-4371-81f1-7cb8ab9b2f2d\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.34 35.89\"><title>quotes</title><path d=\"M12.26,7.06a11.85,11.85,0,0,0,0,23.71h.32c2.49-.15-6,12.36-5.77,12.17,14.74-5.77,17.3-20.32,17.3-24A11.85,11.85,0,0,0,12.26,7.06Z\" transform=\"translate(-0.41 -7.06)\"></path><path d=\"M37.9,7.06a11.85,11.85,0,1,0,0,23.71h.32c2.49-.15-6,12.36-5.77,12.17,14.74-5.77,17.3-20.32,17.3-24A11.85,11.85,0,0,0,37.9,7.06Z\" transform=\"translate(-0.41 -7.06)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Quotes1.svg
// module id = i9lL
// module chunks = 1